export const maxSuggestionsReturned = 50;

const utf8FilenameRegex = /filename\*=UTF-8''([\w%\-.]+)(?:; ?|$)/i;
const asciiFilenameRegex = /^filename=(["']?)(.*?[^\\])\1(?:; ?|$)/i;

// https://stackoverflow.com/questions/40939380/how-to-get-file-name-from-content-disposition
// Slightly modified
export const getFileName = (
  disposition: string,
) => {
  // Get the UTF-8 filename.
  if (utf8FilenameRegex.test(disposition)) {
    const matches = utf8FilenameRegex.exec(disposition);
    if (matches?.[1]) {
      return decodeURIComponent(matches[1]);
    }
  }
  // Fall back to get the ASCII filename.
  // prevent ReDos attacks by anchoring the ascii regex to string start and
  //  slicing off everything before 'filename='
  const filenameStart = disposition.toLowerCase().indexOf('filename=');
  if (filenameStart >= 0) {
    const partialDisposition = disposition.slice(filenameStart);
    const matches = asciiFilenameRegex.exec(partialDisposition);
    if (matches?.[2]) {
      return matches[2];
    }
  }
  return undefined;
};
